exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Icon {\n  float: left; }\n  .Icon svg {\n    height: 24px;\n    width: 24px;\n    display: block; }\n", ""]);

// exports
